import { BehaviorSubject } from 'rxjs';

export class Operation {
  isComplete: boolean;
  isProcessing: boolean;
  hasError: boolean;
  deleteTimer: NodeJS.Timer;
  created: Date;
  operations: BehaviorSubject<Operation[]>;
  deleteTimeoutAfterComplete = 3000;
  deleteTimeoutAfterFail = 10000;
  minDelayFromProcessingToComplete = 0;
  failAfterIdleTimeout = 3600000;

  constructor(operations: BehaviorSubject<Operation[]>) {
    this.operations = operations;
    this.isComplete = false;
    this.isProcessing = false;
    this.hasError = false;
    this.created = new Date();
    this.deleteTimer = setTimeout(() => this.fail(), this.failAfterIdleTimeout);
  }

  fail() {
    this.hasError = true;
    this._setDeleteTimeout(this.deleteTimeoutAfterFail);
    this._update();
  }

  complete() {
    const timeSinceCreation = new Date().getTime() - this.created.getTime();
    let delay = 0;
    if (timeSinceCreation < this.minDelayFromProcessingToComplete) {
      delay = this.minDelayFromProcessingToComplete - timeSinceCreation;
    }
    setTimeout(() => {
      this.isComplete = true;
      this._setDeleteTimeout(this.deleteTimeoutAfterComplete);
      this._update();
    }, delay);
  }

  start() {
    this.isProcessing = true;
    this._update();
  }

  cancel() {
    this._remove();
  }

  private _remove() {
    this.operations.next([...this.operations.value.filter(x => x !== this)]);
  }

  private _update() {
    this.operations.next([...this.operations.value.filter(x => x !== this), this]);
  }

  private _setDeleteTimeout(timeout: number) {
    if (this.deleteTimer) {
      clearTimeout(this.deleteTimer);
    }
    this.deleteTimer = setTimeout(() => this._remove(), timeout);
  }
}
